import type { WorkspaceConfig, WorkspaceConfigSource } from '@/versions/v1/shared/admin-seed';

export type AcceptArbitrarySourceBadge = 'db-set' | 'env-seeded' | 'default-off';

export const ACCEPT_ARBITRARY_HINT =
  'The MIME denylist still applies, and R9 serve hardening (SVG-XSS exclusion, nosniff) still applies — staging a type is not the same as safe arbitrary rendering.';

export function acceptArbitrarySourceBadge(
  source?: WorkspaceConfigSource,
): AcceptArbitrarySourceBadge {
  if (source === 'db') return 'db-set';
  if (source === 'env') return 'env-seeded';
  return 'default-off';
}

export function acceptArbitraryEffectiveLabel(enabled: boolean): 'ON' | 'OFF' {
  return enabled ? 'ON' : 'OFF';
}

export function nextWorkspaceEnabled(config: WorkspaceConfig): WorkspaceConfig {
  return {
    ...config,
    enabled: !config.enabled,
  };
}

export function nextAcceptArbitrary(
  config: WorkspaceConfig,
  nextValue: boolean,
): WorkspaceConfig {
  return {
    ...config,
    acceptArbitraryUploads: nextValue,
  };
}
